var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.027 9.03341C11.747 9.30674 11.587 9.70008 11.627 10.1201C11.687 10.8401 12.347 11.3667 13.067 11.3667H14.3337V12.1601C14.3337 13.5401 13.207 14.6667 11.827 14.6667H4.17366C2.79366 14.6667 1.66699 13.5401 1.66699 12.1601V7.67342C1.66699 6.29342 2.79366 5.16675 4.17366 5.16675H11.827C13.207 5.16675 14.3337 6.29342 14.3337 7.67342V8.63342H12.987C12.6137 8.63342 12.2737 8.78007 12.027 9.03341Z",
    fill: "#AEBFD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90033 2.63342V5.16674H4.17366C2.79366 5.16674 1.66699 6.29341 1.66699 7.67341V5.22676C1.66699 4.43343 2.15366 3.72673 2.89366 3.44673L8.18699 1.44673C9.01366 1.14006 9.90033 1.74675 9.90033 2.63342Z",
    fill: "#AEBFD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0395 9.31327V10.6866C15.0395 11.0533 14.7462 11.3533 14.3729 11.3666H13.0662C12.3462 11.3666 11.6862 10.84 11.6262 10.12C11.5862 9.69995 11.7462 9.30662 12.0262 9.03328C12.2729 8.77995 12.6129 8.6333 12.9862 8.6333H14.3729C14.7462 8.64663 15.0395 8.94661 15.0395 9.31327Z",
    fill: "#AEBFD3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33366 8.5H4.66699C4.39366 8.5 4.16699 8.27333 4.16699 8C4.16699 7.72667 4.39366 7.5 4.66699 7.5H9.33366C9.60699 7.5 9.83366 7.72667 9.83366 8C9.83366 8.27333 9.60699 8.5 9.33366 8.5Z",
    fill: "#AEBFD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.0e75899c.svg";
export { ForwardRef as ReactComponent };